import { render, staticRenderFns } from "./template.vue?vue&type=template&id=dc7289d6&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"
import style0 from "./template.vue?vue&type=style&index=0&id=dc7289d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7289d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc7289d6')) {
      api.createRecord('dc7289d6', component.options)
    } else {
      api.reload('dc7289d6', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=dc7289d6&scoped=true", function () {
      api.rerender('dc7289d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/template.vue"
export default component.exports